import styled from "@emotion/styled";

export const FormFooter = styled.div(({ theme }) => ({
  display: "grid",
  gap: "15px",
  padding: "0 15px 15px",
  flexShrink: 0,
  flexDirection: "column",
}));
